// @flow
import xws from 'api/xws/';
import type { AxiosPromise } from 'axios';

// Constants
import { getService } from 'constants/ajax';

export type Services = {
  discountAmount: number,
  discountType: string,
  serviceId: number,
  serviceName: string
};

export type Promotion = {
  apptEndDate: string,
  apptEndTime: string,
  apptStartDate: string,
  apptStartTime: string,
  daysOfWeek: string,
  promoCode: string,
  promoDiscountAmt: number,
  promoPriority: number,
  promoType: string,
  promotionDescription: string,
  services: Array<Services>
};

type PromotionsType = {
  promotionList: Array<Promotion>,
  success: boolean
};

export type PromotionsResponse = {|
  key?: string,
  promotions: PromotionsType,
  statusCode: number,
  success: boolean
|};

type AnonymousPromotionResponse = {|
  object: Promotion
|};

type RequestData = {|
  date: string,
  promoCode?: string,
  tokenId: string
|};

type PathData = {|
  webkey: string,
  extId: string,
  vin: string
|};

type AnonymousPromoRequestData = {
  promotionCode?: string
};

type AnonymousPromoPathData = {|
  webkey?: string
|};

export function promotionsWS(
  data: RequestData,
  pathData: PathData
): AxiosPromise<RequestData, PromotionsResponse> {
  const promotionsService = getService('promotions');
  promotionsService.setPathVars(pathData);
  return xws(promotionsService).post(promotionsService.getPath(), data);
}

export function anonymousPromotionWS(
  data: ?AnonymousPromoRequestData,
  pathData: AnonymousPromoPathData
): AxiosPromise<AnonymousPromoRequestData, AnonymousPromotionResponse> {
  const anonymousPromotionsService = getService('anonymousPromotion');
  anonymousPromotionsService.setPathVars(pathData);
  return xws(anonymousPromotionsService).post(
    anonymousPromotionsService.getPath(),
    data,
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
}



// WEBPACK FOOTER //
// ./src/api/xws/promotions/promotionsWs.js